import * as t from '@/types'
import Routes from '@/routes'

const variables: t.Variable[] = [
  {
    name: 'Home Insurance',
    type: t.VariableType.single,
    description: 'The amount you pay each month / year to protect your home and contents against damage /loss',
    variable: 'Home_Insurance_Amt',
    frequency: 'Home_Insurance_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Car Insurance',
    type: t.VariableType.single,
    description: 'Include the combined about of all car insurance in your household',
    variable: 'Car_Insurance_Amt',
    frequency: 'Car_Insurance_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Health Insurance',
    type: t.VariableType.single,
    description: 'If you have private medical insurance please highlight the cost paid by you here',
    variable: 'Health_Insurance_Amt',
    frequency: 'Health_Insurance_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Mortgage Protection',
    type: t.VariableType.single,
    description: 'This is the insurance you pay to repay your mortgage should you die unexpectedly',
    variable: 'Mortgage_Protection_Amt',
    frequency: 'Mortgage_Protection_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Life Insurance',
    type: t.VariableType.single,
    // tslint:disable-next-line
    description: 'If you have a life insurance policy that will pay out to your family if you / spouse die unexpectedly',
    variable: 'Life_Insurance_Amt',
    frequency: 'Life_Insurance_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Other Insurance',
    type: t.VariableType.single,
    description: 'If you have any other insurance policy e.g. Specific Illness Cover, Income Protection',
    variable: 'Other_Insurances_Amt',
    frequency: 'Other_Insurances_Freq',
    placeholder: '0.00'
  },
]

const name = 'Protection'
const title = 'Protecting you and your family'
const description = 'If you have a house, paying a mortgage or have a car your probably paying insurance of some type to protect those assets. In this section we ask you to outline the different things your protecting in your life, and what it\'s costing you.'
const outro = ''
const link = Routes.step6

const stepDefinition: t.StepDefinition = {
  index: 6,
  name,
  title,
  description,
  variables,
  outro,
  link,
}

export default stepDefinition
